module.exports = __webpack_public_path__ + "static/img/Curry_h5.0f0e2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Curry_h5.png
// module id = e4iT
// module chunks = 34